import { useContext, useEffect } from "react";
import MainContext from "../../../context/mainContext";
import { Box } from "@mui/material";
import styles from "./Search.module.scss";
import { useTranslation } from "react-i18next";
import SearchResult from "./SearchResult";

const Search: React.FC = () => {
  const { setBanner } = useContext(MainContext);
  const { t } = useTranslation();

  useEffect(() => {
    setBanner("port.png" );
  });

  return (
    <Box className={styles.myInboxMain}>
      <div className={styles.myInboxTitle}>
        <h2>{t("publication")} <strong>{t("publicationHUB")}</strong></h2>
        <h3>{t("searchPublications")}</h3>
      </div>
      <SearchResult title={t("searchResult")} />
    </Box>
  );
};

export default Search;
